export const dumpOrderData = (data) => {
  const { fields, transaction } = data;

  let updatedFields = fields?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
  }));

  let updatedTransaction = {};

  if (transaction.field) {
    updatedTransaction = {
      field: transaction.field_name,
      name: transaction.name,
    };
  }

  return { ...data, fields: updatedFields, transaction: updatedTransaction };
};
